// theme.js
export const blueTheme = {
  body: "#EDF9FE",
  text: "#001C55",
  expTxtColor: "#000a12",
  highlight: "#A6E1FA",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
  splashBg: "#001C55",
};

export const brownTheme = {
  body: "#FFFEFD",
  text: "#5D2A42",
  expTxtColor: "#000a12",
  highlight: "#FFF9EC",
  dark: "#00072D",
  secondaryText: "#8D697A",
  imageHighlight: "#E29F95",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#FB6376",
  headerColor: "#E29F9577",
  splashBg: "#5D2A42",
};

export const purpleTheme = {
  body: "#F8EFF4",
  text: "#231942",
  expTxtColor: "#000a12",
  highlight: "#E0B1CB",
  dark: "#00072D",
  secondaryText: "#655E7A",
  imageHighlight: "#BE95C4",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#5E548E",
  headerColor: "#BE95C477",
  splashBg: "#231942",
};

export const greenTheme = {
  body: "#FFFFEB",
  text: "#003F2F",
  expTxtColor: "#000a12",
  highlight: "#dddf00",
  dark: "#00072D",
  secondaryText: "#4CA58F",
  imageHighlight: "#55a630",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#007f5f",
  headerColor: "#55a63077",
  splashBg: "#003F2F",
};

export const redTheme = {
  body: "#FFF8E6",
  text: "#6a040f",
  expTxtColor: "#000a12",
  highlight: "#ffba08",
  dark: "#03071e",
  secondaryText: "#964F56",
  imageHighlight: "#dc2f02",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#9d0208",
  headerColor: "#dc2f0277",
  splashBg: "#6a040f",
};

export const blackTheme = {
  body: "#E5E5E5",
  text: "#14213d",
  expTxtColor: "#000a12",
  highlight: "#ffffff",
  dark: "#000000",
  secondaryText: "#5A6377",
  imageHighlight: "#fca311",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#fca31177",
  splashBg: "#14213d",
};

export const pinkTheme = {
  body: "#FEE9F2",
  text: "#620E34",
  expTxtColor: "#000a12",
  highlight: "#FBA7CD",
  dark: "#31071A",
  secondaryText: "#ef476f",
  imageHighlight: "#ef476f",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#ef476f77",
  splashBg: "#620E34",
};

export const violetTheme = {
  body: "#F4EEFC",
  text: "#430A58",
  expTxtColor: "#000a12",
  highlight: "#D6BEF4",
  dark: "#21052C",
  secondaryText: "#875599",
  imageHighlight: "#9b5de5",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#763D8B",
  headerColor: "#9b5de577",
  splashBg: "#430A58",
};

export const tealTheme = {
  body: "#E6FAF5",
  text: "#084c61",
  expTxtColor: "#000a12",
  highlight: "#9BEED8",
  dark: "#031E26",
  secondaryText: "#528190",
  imageHighlight: "#07beb8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#56a3a6",
  headerColor: "#07beb877",
  splashBg: "#084c61",
};

export const orangeTheme = {
  body: "#FFF0EA",
  text: "#99401F",
  expTxtColor: "#000a12",
  highlight: "#FFB59A",
  dark: "#33150A",
  secondaryText: "#CC552A",
  imageHighlight: "#FF6B35",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#d7263d",
  headerColor: "#FF6B3577",
  splashBg: "#99401F",
};

export const yellowTheme = {
  body: "#FFD95D",
  text: "#5f4339",
  expTxtColor: "#000a12",
  highlight: "#ffff73",
  dark: "#8d6e63",
  secondaryText: "#5f4339",
  imageHighlight: "#ffea3d",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#4e342e",
  headerColor: "#FFEA3D",
  splashBg: "#5f4339",
};

export const materialDarkTheme = {
  body: "#263238",
  text: "#aeaeae",
  expTxtColor: "#000a12",
  highlight: "#4f5b62",
  dark: "#000a12",
  secondaryText: "#aeaeae",
  imageHighlight: "#607d8b",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8eacbb",
  headerColor: "#34515e",
  splashBg: "#4f5b62",
};

export const materialLightTheme = {
  body: "#ffffff",
  text: "#4c2b91",
  expTxtColor: "#000000",
  highlight: "#E9E3F5",
  dark: "#1d0c41",
  secondaryText: "#7d56c2",
  imageHighlight: "#2b1958",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#7d56c2",
};

export const materialTealTheme = {
  body: "#ffffff",
  text: "#05505E",
  expTxtColor: "#000000",
  highlight: "#a1dded",
  dark: "#07292c",
  secondaryText: "#05505E",
  imageHighlight: "#0a343c",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#05505E",
};

export const materialTealDarkTheme = {
  body: "#121212", // Dark background (near-black)
  text: "#E0F2F1", // Light teal text for readability
  expTxtColor: "#FFFFFF", // White text for emphasis
  highlight: "#26A69A", // Medium teal highlight
  dark: "#263238", // Dark blue-gray for depth
  secondaryText: "#80CBC4", // Lighter teal for secondary information
  imageHighlight: "#00897B", // Darker teal for image highlights
  compImgHighlight: "#1E272C", // Dark complementary color
  jacketColor: "#2C3E50", // Dark slate for "jacket" elements
  headerColor: "#1A2930", // Dark header background
  splashBg: "#004D40", // Deep teal for splash background
};

export const blurDarkTheme = {
  body: "rgba(18, 18, 20, 0.95)", // Nearly black with slight transparency
  text: "rgba(240, 240, 245, 0.9)", // Off-white text with high opacity
  expTxtColor: "rgba(255, 255, 255, 1)", // Pure white for emphasis
  highlight: "rgba(93, 42, 66, 0.7)", // Semi-transparent version of your theme color
  dark: "rgba(0, 0, 0, 0.85)", // Deep black with transparency
  secondaryText: "rgba(192, 160, 175, 0.75)", // Muted pink for secondary text
  imageHighlight: "rgba(226, 159, 149, 0.6)", // Your image highlight with transparency
  compImgHighlight: "rgba(30, 30, 35, 0.65)", // Dark complementary with blur effect
  jacketColor: "rgba(251, 99, 118, 0.75)", // Original jacket color with transparency
  headerColor: "rgba(18, 18, 24, 0.8)", // Dark header with transparency for blur effect
  splashBg: "rgba(93, 42, 66, 0.9)", // Theme color with high transparency

  // Additional properties for blur effects
  backdropFilter: "blur(10px)", // Blur amount for backdrop elements
  backgroundBlur: "blur(15px)", // Stronger blur for background elements
  cardBackground: "rgba(30, 30, 40, 0.65)", // Card background with transparency
  glassBorder: "1px solid rgba(255, 255, 255, 0.1)", // Subtle border for glass effect
  glassShadow: "0 8px 32px rgba(0, 0, 0, 0.2)", // Soft shadow for depth
};

export const blueDarkTheme = {
  body: "#0A1929", // Deep navy blue background (similar to --background-color in dark theme)
  text: "#E3F2FD", // Light blue-white text for readability (similar to --text-color in dark theme)
  expTxtColor: "#FFFFFF", // Pure white for emphasized text
  highlight: "#3F8CFF", // Vibrant blue highlight (similar to --primary-color)
  dark: "#051627", // Darker blue for depth and contrast
  secondaryText: "#90CAF9", // Lighter blue for secondary information (similar to --text-light)
  imageHighlight: "#1E88E5", // Medium blue for image highlights
  compImgHighlight: "#162B44", // Complementary dark blue (similar to --card-bg)
  jacketColor: "#2196F3", // Medium blue accent
  headerColor: "#0D2137", // Slightly lighter than body for header
  splashBg: "#01579B", // Deep blue for splash background
};

export const techFuturisticTheme = {
  body: "#0F172A", // deep navy/charcoal
  text: "#E0F2F1", // soft light for readability
  highlight: "#22D3EE", // neon cyan accent
  dark: "#0a0f1b",
  secondaryText: "#64748B",
  imageHighlight: "#22D3EE",
  compImgHighlight: "#1c2632",
  jacketColor: "#0284C7",
  headerColor: "#02293f77",
  splashBg: "#0A1A2F",
};

export const creativeBoldTheme = {
  body: "#121212",
  text: "#FFFFFF",
  highlight: "#FF6F61", // punchy coral
  dark: "#0d0d0d",
  secondaryText: "#B0B0B0",
  imageHighlight: "#FF6F61",
  compImgHighlight: "#242424",
  jacketColor: "#E63946",
  headerColor: "#FF6F6177",
  splashBg: "#0d0d0d",
};

export const architectPremiumDarkTheme = {
  // Base Background
  body: "#0B1120", // Deep navy (more premium than plain black)
  dark: "#070D18", // Slightly darker depth layer

  // Typography
  text: "#E6EDF3", // High contrast soft white (better readability)
  expTxtColor: "#FFFFFF", // Pure white for headings
  secondaryText: "#9BA4B5", // Muted slate for paragraph text

  // Accent / Highlight
  highlight: "#14B8A6", // Refined teal (not neon)
  imageHighlight: "#0EA5A4", // Slightly deeper teal
  jacketColor: "#1D4ED8", // Deep blue accent for subtle variation

  // UI Elements
  compImgHighlight: "#1E293B", // Card background tone
  headerColor: "#0F172A", // Slightly lighter than body for header
  splashBg: "#0A192F", // Hero splash background

  // Optional glow support (if you use gradient overlays)
  gradientStart: "#0B1120",
  gradientAccent: "rgba(20, 184, 166, 0.15)", // subtle teal glow
};

export const chosenTheme = blueDarkTheme;
